export const getDigitSequence = (length: number, final: number): number[] => {
  const sequence = Array.from({ length }, () => Math.floor(Math.random() * 10));
  return [...sequence, final];
};
